export default __webpack_public_path__ + "67f952e759131c96fc527aafe4265283.png";